import { createAction, props, union } from '@ngrx/store';
import { QuaDistinctFiltersQueryI } from 'src/app/api/qua-distinct-filters/qua-distinct-filters.query.int';
import { QuaDistinctFiltersI } from 'src/app/api/qua-distinct-filters/qua-distinct-filters.result.int';

export const error = createAction('[QUA / Distinct Filters] Error', props<{ messageText: string }>());
export const load = createAction('[QUA / Distinct Filters] Get', props<{
    query: QuaDistinctFiltersQueryI;
}>());
export const received = createAction('[QUA / Distinct Filters] Received', props<{
    result: QuaDistinctFiltersI;
}>());
export const reset = createAction('[QUA / Distinct Filters] Reset', props<Record<string, unknown>>());

const all = union({
    error,
    load,
    received,
    reset,
});
export type Actions = typeof all;
